interface PaginationProps {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  pageSizeOptions?: number[];
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  totalRecords?: number;
}

const PAGE_WINDOW_SIZE = 5;

const Pagination = ({
  currentPage,
  totalPages,
  pageSize,
  pageSizeOptions = [10, 20, 30, 40, 50, 100],
  onPageChange,
  onPageSizeChange,
}: PaginationProps) => {
  const startPage = Math.floor((currentPage - 1) / PAGE_WINDOW_SIZE) * PAGE_WINDOW_SIZE;

  const endPage = Math.min(startPage + PAGE_WINDOW_SIZE, totalPages);

  if (totalPages <= 0) return null;

  // Generate page numbers
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  const displayPages = Array.from({ length: endPage - startPage }, (_, i) => startPage + i + 1);

  const handleClickPrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleClickNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="flex justify-between items-center border bg-[#F2EBEE] border-[#F2EBEE] text-sm text-[#4A082D] p-1">
      {/* Page Size Selector */}
      <div className="text-semibold text-bold bg-[#FFF8ED4D] px-3 py-1 rounded">
        Show{' '}
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="rounded px-2 py-1 bg-[#FFF8ED80] font-lato text-[#4A082D] text-sm"
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>{' '}
        Entries
      </div>

      {/* Pagination Controls */}
      <div className="space-x-2">
        {/* Previous Button */}
        <button
          onClick={handleClickPrevious}
          disabled={currentPage === 1}
          className="px-3 py-1 border-none text-[#4A082D] bg-transparent text-semibold rounded disabled:opacity-50"
        >
          Previous
        </button>

        {/* Page Numbers */}
        {displayPages.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`px-2 py-3 border rounded-md text-[#4A082D] ${
              page === currentPage ? 'bg-[#621C4333]' : 'bg-[#FFF8ED4D] hover:bg-gray-100'
            }`}
          >
            {page}
          </button>
        ))}

        {/* Next Button */}
        <button
          onClick={handleClickNext}
          disabled={currentPage === totalPages}
          className="px-3 py-1 text-[#4A082D] bg-transparent text-sm font-lato text-semibold border-none rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
